import InputGroup from '../components/InputGroup'
import InputHeader from '../components/InputHeader'
import TextInput from '../components/input/TextInput'
import QuillEditor from '../components/input/QuillEditor'
import CheckboxInput from '../components/input/CheckboxInput'
import AsyncDropdownInput from '../components/input/AsyncDropdownInput'
import DropdownInput from '../components/input/DropdownInput'
import DateInput from '../components/input/DateInput'
import TimeSelector from '../components/input/TimeSelector'
import RadioGroupInput from '../components/input/RadioGroupInput'

import {
  getProgramPlanOptions,
  buttonIconOptions,
  patientLang,
  shouldSetDefaultForCheckboxInput,
  externalId,
  startDate,
  employer,
  name,
  coachNotes,
  language,
  objective,
  currentCoachFields,
  actionContentFields,
  lessonContentFields,
  startDay,
  endDay,
  lessonStartDayHeader
  // currentCoach,
  // reminderHeader,
  // reminder
} from './fields'

export const ActionForm = {
  data: {
    component: InputGroup,
    data: {
      ...actionContentFields(),
      adminHeader: {
        component: InputHeader,
        data: {
          header: 'adminHeader.header',
          subheader: 'adminHeader.subheader',
          icon: 'settings'
        }
      },
      shortName: {
        component: TextInput,
        data: {
          name: 'short-name',
          label: 'shortName',
          placeholder: 'shortName',
          required: true
        }
      },
      options: {
        component: InputGroup,
        data: {
          userTrackingHeader: {
            component: InputHeader,
            data: {
              header: 'actionForm.userTrackingHeader.header',
              subheader: 'actionForm.userTrackingHeader.subheader',
              icon: 'tasks'
            }
          },
          userTracking: {
            component: InputGroup,
            data: {
              status: {
                component: CheckboxInput,
                data: {
                  label: 'actionForm.status',
                  disabled: false,
                  default: true
                },
                functions: {
                  shouldSetDefault: shouldSetDefaultForCheckboxInput
                }
              },
              isDaily: {
                component: CheckboxInput,
                data: {
                  label: 'actionForm.isDaily',
                  disabled: true,
                  default: true
                },
                functions: {
                  shouldSetDefault: shouldSetDefaultForCheckboxInput
                }
              }
            }
          },
          durationHeader: {
            component: InputHeader,
            data: {
              header: 'actionForm.durationHeader.header',
              subheader: 'actionForm.durationHeader.subheader',
              icon: 'calendar outline alternate'
            }
          },
          ...startDay(),
          ...endDay(),
          // NOTE: Per action reminder deprecated in Migraine Care 2.0
          // reminderHeader,
          // reminder,
          templateAssignmentHeader: {
            component: InputHeader,
            data: {
              header: 'actionForm.templateAssignmentHeader.header',
              subheader: 'actionForm.templateAssignmentHeader.subheader',
              icon: 'tags'
            }
          },
          belongsToTemplate: {
            component: AsyncDropdownInput,
            data: {
              default: [],
              label: 'actionForm.belongsToTemplate',
              placeholder: 'actionForm.belongsToTemplatePlace',
              multiple: true,
              required: false,
              options: [],
              errorMessage: 'actionForm.errorFetchingTemplates'
            },
            functions: {
              getOptions () {
                return getProgramPlanOptions('action')
              }
            }
          }
        }
      }
    }
  }
}

export const EditActionModal = {
  data: {
    component: InputGroup,
    data: {
      ...actionContentFields(),
      options: {
        component: InputGroup,
        data: {
          // NOTE: Per action reminder deprecated in Migraine Care 2.0
          // reminderHeader,
          // reminder,
          durationHeader: {
            component: InputHeader,
            data: {
              header: 'actionForm.durationHeader.header',
              subheader: 'actionForm.durationHeader.subheader',
              icon: 'calendar outline alternate'
            }
          },
          ...startDay(),
          ...endDay()
        }
      }
    }
  }
}

export const LessonForm = {
  data: {
    component: InputGroup,
    data: {
      ...lessonContentFields(),
      imageHeader: {
        component: InputHeader,
        data: {
          header: 'lessonForm.imageHeader.header',
          subheader: 'lessonForm.imageHeader.subheader',
          icon: 'picture'
        }
      },
      imageLink: {
        component: TextInput,
        data: {
          name: 'image-link',
          label: 'lessonForm.imageLink',
          placeholder: 'lessonForm.imageLinkPlace'
        }
      },
      adminHeader: {
        component: InputHeader,
        data: {
          header: 'adminHeader.header',
          subheader: 'adminHeader.subheader',
          icon: 'settings'
        }
      },
      shortName: {
        component: TextInput,
        data: {
          name: 'short-name',
          label: 'shortName',
          placeholder: 'shortName',
          required: true
        }
      },
      options: {
        component: InputGroup,
        data: {
          ...lessonStartDayHeader(),
          ...startDay(),
          leftButtonHeader: {
            component: InputHeader,
            data: {
              header: 'lessonForm.leftButtonHeader.header',
              subheader: 'lessonForm.leftButtonHeader.subheader',
              icon: 'linkify'
            }
          },
          primaryIcon: {
            component: DropdownInput,
            data: {
              label: 'lessonForm.icon',
              placeholder: 'lessonForm.optional',
              multiple: false,
              required: false,
              options: buttonIconOptions
            }
          },
          primaryText: {
            component: TextInput,
            data: {
              name: 'primary-text',
              label: 'lessonForm.text',
              placeholder: 'lessonForm.optional'
            }
          },
          primaryLink: {
            component: TextInput,
            data: {
              name: 'primary-link',
              label: 'lessonForm.link',
              placeholder: 'lessonForm.optional'
            }
          },
          rightButtonHeader: {
            component: InputHeader,
            data: {
              header: 'lessonForm.rightButtonHeader.header',
              subheader: 'lessonForm.rightButtonHeader.subheader',
              icon: 'linkify'
            }
          },
          secondaryIcon: {
            component: DropdownInput,
            data: {
              label: 'lessonForm.icon',
              placeholder: 'lessonForm.optional',
              multiple: false,
              required: false,
              options: buttonIconOptions
            }
          },
          secondaryText: {
            component: TextInput,
            data: {
              name: 'secondary-text',
              label: 'lessonForm.text',
              placeholder: 'lessonForm.optional'
            }
          },
          secondaryLink: {
            component: TextInput,
            data: {
              name: 'secondary-link',
              label: 'lessonForm.link',
              placeholder: 'lessonForm.optional'
            }
          },
          templateAssignmentHeader: {
            component: InputHeader,
            data: {
              header: 'lessonForm.templateAssignmentHeader.header',
              subheader: 'lessonForm.templateAssignmentHeader.subheader',
              icon: 'tags'
            }
          },
          belongsToTemplate: {
            component: AsyncDropdownInput,
            data: {
              default: [],
              label: 'lessonForm.belongsToTemplate',
              placeholder: 'lessonForm.belongsToTemplatePlace',
              multiple: true,
              required: false,
              options: [],
              errorMessage: 'lessonForm.errorFetchingTemplates'
            },
            functions: {
              getOptions () {
                return getProgramPlanOptions('lesson')
              }
            }
          }
        }
      }
    }
  }
}

export const EditLessonModal = {
  data: {
    component: InputGroup,
    data: {
      ...lessonContentFields(),
      ...lessonStartDayHeader(),
      options: {
        component: InputGroup,
        data: {
          ...startDay()
        }
      }
    }
  }
}

export const EditPatientForm = {
  contentHeader: {
    component: InputHeader,
    data: {
      header: 'patients.profile.patientProfile.header',
      subheader: 'patients.profile.patientProfile.subheader',
      icon: 'user'
    }
  },
  externalId,
  employer,
  name,
  // NOTE: Consent can only be set by user
  // consent: {
  //   component: CheckboxInput,
  //   data: {
  //     label: 'patients.profile.consent',
  //     disabled: true
  //   }
  // },
  data: {
    component: InputGroup,
    data: {
      language,
      // TODO: Renamed back to `objective` for Migraine Care 2.0
      // objectives: {
      objective,
      ...startDate(true),
      endDate: {
        component: DateInput,
        data: {
          label: 'patients.profile.endDate',
          placeholder: 'patients.profile.endDate'
        }
      },
      coachNotes,
      ...currentCoachFields(),
      coachReminderSettings: {
        component: InputGroup,
        data: {
          contentHeader: {
            component: InputHeader,
            data: {
              header: 'patients.profile.reminderSettings.header',
              subheader: 'patients.profile.reminderSettings.subheader',
              icon: 'bell'
            }
          },
          patientLang,
          // NOTE: Field is programmatically populated
          // lastDocReminder: {},
          // shouldSendDocReminder: {
          //   component: CheckboxInput,
          //   data: {
          //     label: 'patients.profile.shouldSendDocReminder',
          //     // default: false
          //   }
          // },
          // NOTE: Field is programmatically populated
          // lastCoachReminder: {},
          // shouldSendCoachReminder: {
          //   component: CheckboxInput,
          //   data: {
          //     label: 'patients.profile.shouldSendCoachReminder',
          //     // default: false
          //   }
          // },
          missingDocumentList: {
            // component:
          }
          // NOTE: Field is programmatically populated
          // lastMissingDocumentReminder: {}
        }
      }
    }
  }
}

export const NewPatientForm = {
  email: {
    component: TextInput,
    data: {
      required: true,
      disabled: true,
      label: 'patients.create.email',
      placeholder: 'patients.create.emailPlace'
    }
  },
  externalId,
  employer,
  name,
  data: {
    component: InputGroup,
    data: {
      language,
      // TODO: Renamed to `objective` for Migraine Care 2.0
      // objectives: {
      objective,
      ...startDate(false, true),
      coachNotes,
      ...currentCoachFields()
    }
  }
}

export const DocumentsReminderForm = {
  questionnaire: {
    component: CheckboxInput,
    data: {
      label: 'patients.profile.questionnaire'
    }
  },
  diary: {
    component: CheckboxInput,
    data: {
      label: 'patients.profile.diary'
    }
  }
}

export const NewAppointmentForm = {
  date: {
    component: DateInput,
    data: {
      required: true,
      minDate: new Date(),
      label: 'patients.appointments.date',
      placeholder: 'patients.appointments.date'
    }
  },
  time: {
    component: TimeSelector,
    data: {
      default: null,
      required: true,
      label: 'patients.appointments.time'
    }
  },
  data: {
    component: InputGroup,
    data: {
      appointmentType: {
        component: RadioGroupInput,
        data: {
          required: true,
          label: 'patients.appointments.type',
          placeholder: 'patients.appointments.type',
          options: [
            {
              label: 'patients.appointments.coach',
              value: 'coach',
              disabled: false
            },
            {
              label: 'patients.appointments.doctor',
              value: 'doctor',
              disabled: false
            }
          ]
        }
      }
      // NOTE: Per-event reminder setting is not in use yet
      // hasReminder: {
      //   component: CheckboxInput,
      //   data: {
      //     default: false,
      //     label: 'patients.appointments.scheduleReminderLong'
      //   }
      // }
    }
  }
}

export const ValidateEmailForm = {
  email: {
    component: TextInput,
    data: {
      required: true,
      label: 'patients.create.email',
      placeholder: 'patients.create.emailPlace'
    }
  }
}
